function initArcText() {
  Array.from(document.querySelectorAll('[data-arc-text]')).forEach($elem => {
    if ($elem.getAttribute('data-arc-text-loaded') === 'true') return;

    const circle = new CircleType($elem);
    const radius = parseInt($elem.getAttribute('data-arc-text-radius') || '33')

    circle.radius(radius);
    circle.forceHeight(false);
    circle.forceWidth(false);

    $elem.style.transform = 'rotate(-15deg)'

    $elem.setAttribute('data-arc-text-loaded', 'true');
  })
}

function initArcTextInProductRecommendations() {
  document.addEventListener('recommendations:ready', () => {
    initArcText();
  });
}

async function addItemToCart(id, quantity = 1) {
  let payload = {
    items: [{
      id: id,
      quantity: quantity,
    }]
  };

  const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  const responseJson = await response.json();

  return responseJson?.items?.[0].id === id;
}

function initAddToCartButtons() {
  const $buttons = Array.from(document.querySelectorAll('[data-cart-add]'));

  $buttons.forEach($button => {
    $button.addEventListener('click', async () => {
      const productId = $button.getAttribute('data-cart-add');

      $button.setAttribute('data-cart-loading', true);
      await addItemToCart(productId);

      $button.removeAttribute('data-cart-loading');
    })
  });
}

async function waitForRechargeInit() {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      clearInterval(id);
      reject();
    }, 2000);

    const id = setInterval(() => {
      if (!('ReCharge' in window)) {
        console.log('no recharge')
        return;
      }
      if (!ReCharge.products) return;
      if (!ReCharge.products[0]) return;
      if (!ReCharge.products[0].elements) return;
      if (!ReCharge.products[0].elements[0]) return;

      clearInterval(id);
      clearTimeout(timeoutId);

      resolve();
    }, 100);
  });
}

async function initSubscriptionFrequency() {
  try {
    await waitForRechargeInit();
  } catch (err) {
    // No recharge available after 2 seconds
    return;
  }

  const $subscriptionFrequencyDropdown = document.querySelector('#subscription-frequency-select');
  const $autoDeliverContainer = document.querySelector('#rc_autodeliver_options');

  $subscriptionFrequencyDropdown.parentElement.removeChild($subscriptionFrequencyDropdown);
  $autoDeliverContainer.parentElement.appendChild($subscriptionFrequencyDropdown);

  const $frequencySelectContainer = document.querySelector('#subscription-frequency-select');
  if (!$frequencySelectContainer) return;

  const $frequencySelect = $frequencySelectContainer.querySelector('select');

  const { shipping_interval_frequency, shipping_interval_unit_type } = ReCharge.products[0];

  shipping_interval_frequency.forEach(number => {
    const option = document.createElement('option');

    option.value = number;
    option.innerText = `Every `;

    if (number > 1) {
      option.innerText += `${number} ${shipping_interval_unit_type.toLowerCase()}`;
    } else {
      option.innerText += shipping_interval_unit_type.substring(0, shipping_interval_unit_type.length - 1).toLowerCase();
    }

    $frequencySelect.appendChild(option);
  });

  $frequencySelect.onchange = function(e) {
    const { value } = e.target;

    ReCharge.products[0].elements[0].shippingIntervalFrequency.value = value;
  }
}

if (['interactive', 'complete'].includes(document.readyState)) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init);
}


function init() {
  initArcText();
  initArcTextInProductRecommendations();
  initAddToCartButtons();
  initSubscriptionFrequency();
}